import React from 'react';
import classnames from 'classnames';
import classes from './notification.scss';
export function Notification({
  errorClassName,
  error,
  warning,
  showNotification,
  dataLabel
}) {
  if (!showNotification) {
    return null;
  }
  if (error) {
    return /*#__PURE__*/React.createElement("span", {
      className: classnames(errorClassName, classes.error),
      "data-label": dataLabel
    }, error);
  } else if (warning) {
    return /*#__PURE__*/React.createElement("span", {
      className: classnames(errorClassName, classes.warning)
    }, warning);
  }
  return null;
}